import { useQuery } from 'react-query';
import { getDiscountApprovers, getDiscountReasons, getSystemDiscounts } from 'queries';
import { getDiscountTypeTemplates } from 'queries/common/getDiscountTypes';

export const useDiscountData = (customerId?: string) => {
  const { data: discountReasons, isLoading: isReasonsLoading } = useQuery('discount-types', getDiscountReasons);
  const { data: discountTypeTemplates, isLoading: isTemplatesLoading } = useQuery(
    ['discount-type-templates', undefined],
    getDiscountTypeTemplates,
  );
  const { data: discountApprovers, isLoading: isApproversLoading } = useQuery(
    'discounts-approved-by-users',
    getDiscountApprovers,
  );
  const { data: systemDiscounts, isLoading: isSystemDiscountsLoading } = useQuery(['discounts', customerId], getSystemDiscounts);

  const isLoading = isReasonsLoading || isTemplatesLoading || isApproversLoading || isSystemDiscountsLoading;

  return { discountReasons, discountTypeTemplates, discountApprovers, systemDiscounts, isLoading };
};
